import React, { Component } from 'react'
import { Row, Col, UncontrolledAlert } from 'reactstrap';
import '../App.css';
import LoggedContext from '../BusinessObjects/LoggedContext'
import cubeApiClient from '../BusinessObjects/cubeApiService';
import EsaedroMenu from './EsaedroMenu';
import EsaedroObjectsList from './EsaedroObjectsList';
import EsaedroObjectEdit from './EsaedroObjectEdit';
import EsaedroObjectDelete from './EsaedroObjectDelete';
import EsaedroMenuHistory from './EsaedroMenuHistory';
import EsaedroJumpMenu from './EsaedroJumpMenu';
import EsaedroResourceFilter from '../Models/EsaedroResourceFilter';
import { themeCol9, themeGroup, themeSpinner } from '../Utils/EsaedroTheme';
import EsaedroHistoryItem from '../Models/EsaedroHistoryItem';


interface IEsaedroContentPageProps {
  name?:string
  className?:string
  onChange?(event: any): void
}
interface IEsaedroContentPageState
{
  menuHistory: EsaedroHistoryItem[];
  selectedHistoryItem: EsaedroHistoryItem
  loading: boolean
  errorMessage: string
  successMessage: string
}

export default class EsaedroContentPage extends Component<IEsaedroContentPageProps, IEsaedroContentPageState> {
  static contextType = LoggedContext
  context!: React.ContextType<typeof LoggedContext>

  // Utilizzato per forzare il rendering quando si clicca su una menuHistory
  incrementalKey: number = 0

  constructor(props: IEsaedroContentPageProps){
      super(props);

      // Creo la home manualmente, un item fittizio con Id = 0
      let homeHistoryItem = new EsaedroHistoryItem({Description: "Home", Id: "0"})
      this.state={
        selectedHistoryItem: homeHistoryItem,
        menuHistory:[homeHistoryItem], 
        loading:true,
        errorMessage:'',
        successMessage:''
      };
  }

  componentDidMount()
  {
    if (!this.state.selectedHistoryItem.menuItems.length)
    {
      const service = new cubeApiClient();
      const t = this.context.tokenAPI;
      var requrl ="api/sys/MenuItems?RecordSelection=ParentMenuId is null"  

      // Controllo se ho un token di autorizzazione
      if (t != "")
      {
        service
        .getItems(requrl,t)
        .then((data: any) => {

            // Creo il Menu iniziale
            if (data)
            {
              this.setState(prevState => ({
                ...prevState.selectedHistoryItem.menuItems=data,
                loading:false
              }))  
            }
            else this.setState({
              loading: false, 
              errorMessage: "Si è verificato un problema nello scaricare i dati."
            })
        },
        (error: any) => {
            this.setState({ 
              loading: false, 
              errorMessage: error 
            });
        });
      }
      
      // Non ho un token valido quindi devo rifare il login
      else {
        this.setState({
          loading: false, 
          errorMessage: "Si prega di effettuare il login."
        })
      }
      
    }
  }

  onMenuClick = (id: any) => {
    // Recupero la voce di menu cliccata. Non è posizionale ma si basa sull'Id. Si può cambiare? Conviene?
    let selectedVoices : any = this.state.selectedHistoryItem.menuItems[0].Id
      ? this.state.selectedHistoryItem.menuItems.filter(item => (item.Id == id))
      : undefined
    if (selectedVoices!=undefined && selectedVoices.length > 0) {

      this.setState({
        loading: true,
        successMessage:'',
        errorMessage:''
      })
      const service = new cubeApiClient();
      const t = this.context.tokenAPI;
      let voiceID =  selectedVoices[0].Id
        ? selectedVoices[0].Id.toString()
        : undefined

      if (voiceID) {

        var requrl ="api/sys/MenuItems?RecordSelection=ParentMenuId=" + voiceID ; 
  
        service
            .getItems(requrl,t)
            .then((data: any) => {
                // Creo il nuovo HistoryItem, con relativo Menu, lo aggiungo allo storico e lo rendo attivo
                if (data)
                {
                    let newSelectedItem = new EsaedroHistoryItem(selectedVoices[0])
                    // gli setto il customComponent se presente
                    newSelectedItem.customComponentName = newSelectedItem.selectedItem.CustomEditComponent
                    newSelectedItem.menuItems=data
                    this.setState(prevState => ({
                      selectedHistoryItem: newSelectedItem,
                      menuHistory: [...prevState.menuHistory, newSelectedItem],
                      loading:false
                    }))  
                }
                
                else this.setState({
                  loading: false, 
                  errorMessage: "Si è verificato un problema nello scaricare i dati del Menu."
                })
            },
            (error: any) => {
                this.setState({ 
                  loading: false, 
                  errorMessage: error 
                });
            });
        }
        else {
          this.setState({ 
            loading: false, 
            errorMessage: "Si è verificato un errore nel recuperare le voci di menu" 
          });
        }
      
    }
    else 
    {
      this.setState({ 
        loading: false, 
        errorMessage: "Si è verificato un errore nel recuperare le voci di menu" 
      });
    }
  }

  onMenuHistoryClick = (id: any) => {

    /***********************************************************************
        Un piccolo passo per il codice, un grande passo per l'umanità
        Questo semplice incrementale, che va propagato su TUTTI gli 
        oggetti figli della content page e passato alla loro property key,
        fa si che ogni volta che si clicchi su uno history il componente 
        figlio faccia un'unmount e una mount, ricaricando 
        tutti i dati in maniera corretta
    ***********************************************************************/
    this.incrementalKey++

    // Recupero la voce di menu history cliccata. Non è posizionale ma si basa sull'Id. Si può cambiare? Conviene?
    let selectedVoices : any = this.state.menuHistory[0].selectedItem.Id
      ? this.state.menuHistory.filter(item => (item.selectedItem.Id == id))
      : undefined
    
    if (selectedVoices!=undefined) {

      this.setState({
        loading: true,
        successMessage:'',
        errorMessage:''
      })
      // Creo un nuovo array come HisoryMenu, e gli aggiungo tutte le voci di history menu sino alla selezionata
      let i: number
      let newHistory: EsaedroHistoryItem[] = []
      for (i=0; i<this.state.menuHistory.length; i++) {
        newHistory.push(this.state.menuHistory[i])
        if (this.state.menuHistory[i].selectedItem.Id==id) break
      }
      // Imposto il menu history selezionato come attivo
      this.setState({
        menuHistory: newHistory, 
        selectedHistoryItem: selectedVoices[0], 
        loading:false
      })
    }

    else this.setState({
      loading:false,
      errorMessage: "Si è verificato un problema nel ricaricare il Menu History.",
      successMessage:''
    })
  }

  onJumpMenuClick = (jumpName: any) => {

     // Recupero la voce di menu jump cliccata. Non è posizionale ma si basa sul JumpName. Si può cambiare? Conviene?
    let selectedVoices : any = this.state.selectedHistoryItem.jumpMenuItems.filter(item => (item.JumpName == jumpName))
    if (selectedVoices!=undefined) {
      
      // Clono l'HistoryItem in cui mi trovavo e aggiungo le informazioni relative al salto
      let newHistoryItem = this.state.selectedHistoryItem.cloneSelf()
      newHistoryItem.itemToJump=selectedVoices[0]
      //alert(JSON.stringify(selectedVoices[0]))
      newHistoryItem.jumpMenuItems=[]

      // Qui creo gli EsaedroResourceFilters da mettere come selectedItemFilters - Al momento non gestiamo la description
      let itemFilters: EsaedroResourceFilter[] = []
      if (selectedVoices[0].ResourcesJumpFilters) {
        selectedVoices[0].ResourcesJumpFilters.forEach((element: { DestinationFieldName: string, SourceFieldName: string; FilterOperator: string; }) => {
          itemFilters.push(new EsaedroResourceFilter(element.DestinationFieldName, newHistoryItem.itemToEdit[element.SourceFieldName] ,element.FilterOperator))
        });
      }
      newHistoryItem.selectedItemFilters=itemFilters

      // Resetto gli altri oggetti di stato
      newHistoryItem.itemToEdit=undefined
      newHistoryItem.itemToDel=undefined
      newHistoryItem.newItem=false

      // Metto la starting page a 1 per le liste successive che partiranno da questa
      newHistoryItem.startingPage=1

      // Salvo il customComponentName in caso ci sia
      newHistoryItem.customComponentName = newHistoryItem.itemToJump.DestinationCustomEditComponent

      // Setto correttamente le varie proprietà del nuovo SelectedItem
      newHistoryItem.selectedItem.Id=newHistoryItem.selectedItem.Id+"_"+jumpName
      newHistoryItem.selectedItem.Description=selectedVoices[0].JumpLabel
      newHistoryItem.selectedItem.ResourceName=selectedVoices[0].DestinationResourceName
      newHistoryItem.selectedItem.EndPoint=selectedVoices[0].DestinationEndPoint

      // Aggiungo il nuovo History Item alla menu history e imposto il nuovo Item come attivo
      this.setState(prevState => ({
        selectedHistoryItem: newHistoryItem,
        menuHistory: [...prevState.menuHistory, newHistoryItem],
        successMessage:'',
        errorMessage:''
      }))
    }
  }

  OnEditClick = (objToEdit: any) => {
    
    this.setState({
      loading: true,
      successMessage:'',
      errorMessage:''
    })
    const service = new cubeApiClient();
    const t = this.context.tokenAPI;
    var requrl ="api/sys/ResourcesJumps?RecordSelection=SourceResourceName='" + this.state.selectedHistoryItem.selectedItem.ResourceName +"'" ; 

    let jumpItems: EsaedroResourceFilter[] = []
    service
        .getItems(requrl,t)
        .then((data: any) => {
            // Creo il nuovo HistoryItem, con relativo  JumpMenu, lo aggiungo allo storico e lo rendo attivo
            if (data)
            {
                jumpItems = data
            }
                    
            // Come prima cosa clono il mio selectedItem
            let newHistoryItem = this.state.selectedHistoryItem.cloneSelf()
            newHistoryItem.itemToEdit=objToEdit
            // Svuoto eventuali filtri in input che possono essere stati clonati
            newHistoryItem.listInputFilters=[]
            // Gli aggiungo eventuali jumpItems recuperati dal servizio
            newHistoryItem.jumpMenuItems=jumpItems
            // Metto la starting page a 1 per le liste successive che partiranno da questa
            newHistoryItem.startingPage=1
            
            // Aggiungo la voce all'history menu e poi setto questo item come selectedItem
            newHistoryItem.selectedItem.Id=newHistoryItem.selectedItem.Id+"_"+objToEdit.Id
            newHistoryItem.selectedItem.Description=newHistoryItem.selectedItem.Description+" - Dettaglio"
            this.setState(prevState => ({
              selectedHistoryItem: newHistoryItem,
              menuHistory: [...prevState.menuHistory, newHistoryItem],
              loading: false
            }))

        },
        (error: any) => {
            this.setState({ 
              loading: false, 
              errorMessage: error 
            });
        });    
  }

  OnDeleteClick = (objToDelete: any) => {
    let newHistoryItem = this.state.selectedHistoryItem.cloneSelf()
    // Setto le nuove proprietà al mio history object
    newHistoryItem.itemToEdit=undefined
    newHistoryItem.itemToDel=objToDelete
    newHistoryItem.newItem=false
    // Aggiungo la voce all'history menu e poi setto questo item come selectedItem
    newHistoryItem.selectedItem.Id=newHistoryItem.selectedItem.Id+"_DEL"
    newHistoryItem.selectedItem.Description="Elimina " + newHistoryItem.selectedItem.Description
    this.setState(prevState => ({
      selectedHistoryItem: newHistoryItem,
      menuHistory: [...prevState.menuHistory, newHistoryItem],
      successMessage:'',
      errorMessage:''
    }))
  }

  OnReturnToList = (returnMessage?: string) => {
    this.popLastHistoryItemAndUpdateSelected(returnMessage)
  }

  popLastHistoryItemAndUpdateSelected = (returnMessage?:string) => {
    let newHistory = this.state.menuHistory
    newHistory.pop()
    this.setState({
      menuHistory: newHistory, 
      selectedHistoryItem: newHistory[newHistory.length-1],
      successMessage:returnMessage?returnMessage:'',
      errorMessage:''
    })
  }

  OnNewItem = () => {
    let newHistoryItem = this.state.selectedHistoryItem.cloneSelf()
    // Setto le nuove proprietà al mio history object
    newHistoryItem.itemToEdit=undefined
    newHistoryItem.itemToDel=undefined
    newHistoryItem.newItem=true
    // Metto la starting page a 1 per le liste successive che partiranno da questa
    newHistoryItem.startingPage=1
    // Aggiungo la voce all'history menu e poi setto questo item come selectedItem
    newHistoryItem.selectedItem.Id=newHistoryItem.selectedItem.Id+"_NEW"
    newHistoryItem.selectedItem.Description="Crea " + newHistoryItem.selectedItem.Description
    this.setState(prevState => ({
      selectedHistoryItem: newHistoryItem,
      menuHistory: [...prevState.menuHistory, newHistoryItem],
      successMessage:'',
      errorMessage:''
    }))
  }

  OnListFiltersUpdate = (filters: EsaedroResourceFilter[]) => {
    let newFilters : EsaedroResourceFilter[] = []
    filters.forEach(filter => {
      newFilters.push(new EsaedroResourceFilter(filter.FieldName, filter.Value, filter.Operator, filter.description))
    });
    this.state.selectedHistoryItem.listInputFilters = newFilters
  }

  OnListPageUpdate = (newPage: number) => {
    this.state.selectedHistoryItem.startingPage = newPage
  }

  clearDetailState = () => {
    this.setState({
      loading: true,
      successMessage:'',
      errorMessage:''})
    this.state.selectedHistoryItem.clearDetailState()
    this.setState({loading: false})
  }

  clearJumpState = () => {
    this.setState({
      loading: true,
      successMessage:'',
      errorMessage:''
    })
    this.state.selectedHistoryItem.clearJumpState()
    this.setState({loading: false})
  }

  render() {

    if (this.state.loading)
    {
      return (
        <Row className={this.props.className?this.props.className:themeGroup()}>
          <Col className={themeCol9()}>
            <i className={themeSpinner()}></i>   Caricamento...  
          </Col>
        </Row>
      )
    }

    else 
    {
      var successMessageAlert = (
        (this.state.successMessage != '')?
          <UncontrolledAlert color="success">
            {this.state.successMessage}
          </UncontrolledAlert>
        : undefined
      
      )
      var pageContent = undefined
      if (this.state.selectedHistoryItem.selectedItem.EndPoint!=undefined || this.state.selectedHistoryItem.itemToJump) {


        /*********ERRORE *******************/
        if (this.state.errorMessage!='') {
          pageContent = <Row className={this.props.className?this.props.className:themeGroup()}>
                          <Col className={themeCol9()}>
                            <UncontrolledAlert color="danger">
                              {this.state.errorMessage}  
                              {this.state.selectedHistoryItem.selectedItem.name}
                              {this.state.selectedHistoryItem.selectedItem.DestinationResourceName}
                            </UncontrolledAlert>
                          </Col>
                        </Row>
        }

        /************** Edit componente con gestione custom (Lazy Loading) ***********/
        // TODO capire come gestire errore nel nome risorsa custom
        if (this.state.selectedHistoryItem.customComponentName && this.state.selectedHistoryItem.customComponentName != '' && this.state.selectedHistoryItem.itemToEdit) {
           const CustomComponent = React.lazy(() => import("./CustomComponents/"+this.state.selectedHistoryItem.customComponentName))
           pageContent = <React.Suspense fallback="Caricamento componente...">
                          <CustomComponent 
                            myObjType={this.state.selectedHistoryItem.selectedItem.ResourceName} 
                            myObjUrl={this.state.selectedHistoryItem.selectedItem.EndPoint} 
                            myObj={this.state.selectedHistoryItem.itemToEdit} 
                            isNew={false} 
                            filters='' 
                            key={this.incrementalKey}
                            fixedFields={this.state.selectedHistoryItem.selectedItemFilters}
                            onReturn={this.OnReturnToList}> 
                          </CustomComponent>
                        </React.Suspense> 
        }

        /************** New componente con gestione custom (Lazy Loading) ***********/
        // TODO capire come gestire errore nel nome risorsa custom
        else if (this.state.selectedHistoryItem.customComponentName && this.state.selectedHistoryItem.customComponentName != '' && this.state.selectedHistoryItem.newItem) {
          const CustomComponent = React.lazy(() => import("./CustomComponents/"+this.state.selectedHistoryItem.customComponentName))
          pageContent = <React.Suspense fallback="Caricamento componente...">
                          <CustomComponent 
                            myObjType={this.state.selectedHistoryItem.selectedItem.ResourceName} 
                            myObjUrl={this.state.selectedHistoryItem.selectedItem.EndPoint} 
                            isNew={true} 
                            filters='' 
                            key={this.incrementalKey}
                            fixedFields={this.state.selectedHistoryItem.selectedItemFilters}
                            onReturn={this.OnReturnToList}> 
                          </CustomComponent>
                       </React.Suspense> 
        }

        /******** Dettaglio - Modifica *********/
        // TODO - Cambiare la gestione dei filtri? - Passare un elenco di campi vincolati? Ad esempio in caso di jump
        else if (this.state.selectedHistoryItem.itemToEdit) {
          pageContent = <EsaedroObjectEdit 
                          myObjType={this.state.selectedHistoryItem.selectedItem.ResourceName} 
                          myObjUrl={this.state.selectedHistoryItem.selectedItem.EndPoint} 
                          myObj={this.state.selectedHistoryItem.itemToEdit} 
                          myObjResourceID={this.state.selectedHistoryItem.selectedItem.Resource_ID}
                          isNew={false} 
                          filters='' 
                          key={this.incrementalKey}
                          fixedFields={this.state.selectedHistoryItem.selectedItemFilters}
                          onReturn={this.OnReturnToList}> 
                        </EsaedroObjectEdit>
        }
        /******** Dettaglio - Elimina *********/
        else if (this.state.selectedHistoryItem.itemToDel) {
          pageContent = <EsaedroObjectDelete 
                          myObjType={this.state.selectedHistoryItem.selectedItem.ResourceName}  
                          myObjUrl={this.state.selectedHistoryItem.selectedItem.EndPoint} 
                          myObj={this.state.selectedHistoryItem.itemToDel} 
                          key={this.incrementalKey}
                          onReturn={this.OnReturnToList} > 
                        </EsaedroObjectDelete>
        }
        /******** Dettaglio - Crea *********/
        // TODO - Cambiare la gestione dei filtri? - Passare un elenco di campi vincolati? Ad esempio in caso di jump
        else if (this.state.selectedHistoryItem.newItem) {
          pageContent = <EsaedroObjectEdit   
                          myObjType={this.state.selectedHistoryItem.selectedItem.ResourceName} 
                          myObjUrl={this.state.selectedHistoryItem.selectedItem.EndPoint} 
                          myObjResourceID={this.state.selectedHistoryItem.selectedItem.Resource_ID}
                          isNew={true} 
                          filters='' 
                          key={this.incrementalKey}
                          fixedFields={this.state.selectedHistoryItem.selectedItemFilters}
                          onReturn={this.OnReturnToList}> 
                        </EsaedroObjectEdit>
        }
        // Gestisco i vari casi di render per il content della pagina
        /******** Jump *********/
        else if (this.state.selectedHistoryItem.itemToJump) {
          pageContent = <EsaedroObjectsList 
                          myObjType={this.state.selectedHistoryItem.itemToJump.DestinationResourceName} 
                          myObjUrl={this.state.selectedHistoryItem.itemToJump.DestinationEndPoint} 
                          onObjectEdit={this.OnEditClick} 
                          onObjectDelete={this.OnDeleteClick} 
                          onObjectCreate={this.OnNewItem}
                          navigationFilters={this.state.selectedHistoryItem.selectedItemFilters}
                          key={this.incrementalKey}
                          canCreate={this.state.selectedHistoryItem.itemToJump.DestinationCanCreate}
                          canUpdate={this.state.selectedHistoryItem.itemToJump.DestinationCanUpdate}
                          canDelete={this.state.selectedHistoryItem.itemToJump.DestinationCanDelete}
                          onInputFiltersUpdate={this.OnListFiltersUpdate}
                          onPageUpdate={this.OnListPageUpdate}
                          startingInputFilters={this.state.selectedHistoryItem.listInputFilters}
                          startingPage={this.state.selectedHistoryItem.startingPage}> 
                        </EsaedroObjectsList>
        }
        /******** Lista - Testate-Righe *********/
        else if (this.state.selectedHistoryItem.selectedItem.ChildResourceName != undefined) {
          pageContent = <EsaedroObjectsList 
                          myObjType={this.state.selectedHistoryItem.selectedItem.ResourceName} 
                          myObjUrl={this.state.selectedHistoryItem.selectedItem.EndPoint} 
                          myRowObjType={this.state.selectedHistoryItem.selectedItem.ChildResourceName} 
                          myRowObjUrl={this.state.selectedHistoryItem.selectedItem.ChildEndPoint}
                          myRowObjLinkFields={this.state.selectedHistoryItem.selectedItem.ChildLinkFields} 
                          onObjectEdit={this.OnEditClick} 
                          onObjectDelete={this.OnDeleteClick} 
                          onObjectCreate={this.OnNewItem}
                          key={this.incrementalKey}
                          canCreate={this.state.selectedHistoryItem.selectedItem.CanCreate}
                          canUpdate={this.state.selectedHistoryItem.selectedItem.CanUpdate}
                          canDelete={this.state.selectedHistoryItem.selectedItem.CanDelete}
                          onInputFiltersUpdate={this.OnListFiltersUpdate}
                          onPageUpdate={this.OnListPageUpdate}
                          startingInputFilters={this.state.selectedHistoryItem.listInputFilters}
                          startingPage={this.state.selectedHistoryItem.startingPage}>
                        </EsaedroObjectsList>
        }
        /******** Lista *********/
        else {
          pageContent = <EsaedroObjectsList 
                          myObjType={this.state.selectedHistoryItem.selectedItem.ResourceName} 
                          myObjUrl={this.state.selectedHistoryItem.selectedItem.EndPoint} 
                          onObjectEdit={this.OnEditClick} 
                          onObjectDelete={this.OnDeleteClick} 
                          onObjectCreate={this.OnNewItem}
                          key={this.incrementalKey}
                          canCreate={this.state.selectedHistoryItem.selectedItem.CanCreate}
                          canUpdate={this.state.selectedHistoryItem.selectedItem.CanUpdate}
                          canDelete={this.state.selectedHistoryItem.selectedItem.CanDelete}
                          onInputFiltersUpdate={this.OnListFiltersUpdate}
                          onPageUpdate={this.OnListPageUpdate}
                          startingInputFilters={this.state.selectedHistoryItem.listInputFilters}
                          startingPage={this.state.selectedHistoryItem.startingPage}>
                        </EsaedroObjectsList>
        }
      }

      return (
        <React.Fragment> 
          <EsaedroMenuHistory 
            name="Content Page History Menu" 
            className={this.props.className?this.props.className:themeGroup()} 
            items={this.state.menuHistory} 
            onClick={this.onMenuHistoryClick} >
          </EsaedroMenuHistory>
          <EsaedroMenu 
            name="Content Page Menu" 
            className={this.props.className?this.props.className:themeGroup()} 
            items={this.state.selectedHistoryItem.menuItems} 
            onClick={this.onMenuClick} > 
          </EsaedroMenu>
          {
            // Lo visualizzo solo in caso di Edit e solo se ci sono jump items
            this.state.selectedHistoryItem.itemToEdit && this.state.selectedHistoryItem.jumpMenuItems
              ? <EsaedroJumpMenu 
                  name="Content Page Jump Menu" 
                  className={this.props.className?this.props.className:themeGroup()} 
                  items={this.state.selectedHistoryItem.jumpMenuItems} 
                  onClick={this.onJumpMenuClick} > 
                </EsaedroJumpMenu>
              : undefined
          }
          {successMessageAlert}
          {pageContent}
        </React.Fragment>
      )
    }
  }
}
  